import React from "react";
import { useSelector } from "react-redux";
import AvatarCircle from "../General-UI/AvatarCircle";
import RecordingRedDot from "../General-UI/RecordingRedDot";
import TakePicControls from "./TakePicControls";
import RenderUseCameraFeed from "./RenderUseCameraFeed";
import {
  PT_FILE,
  PT_USE_CAMERA,
  PT_EXISTING,
  PT_NONE,
  PT_SNAPPED_PICTURE,
  selectPreviewType,
  selectPicToUpload,
} from "slices/createPictureSlice";
import { AVATAR_CDN } from "constants/constants";
import { selectCurrentUserAttributes } from "slices/authSlice";

const AvatarDisplay = () => {
  const previewType = useSelector(selectPreviewType);
  const picToUpload = useSelector(selectPicToUpload);
  const currentUserAttributes = useSelector(selectCurrentUserAttributes);
  function renderPicPreview() {
    switch (previewType) {
      case PT_FILE:
      case PT_SNAPPED_PICTURE:
        return <img alt="snapped" src={URL.createObjectURL(picToUpload)} />;
      case PT_EXISTING:
        return (
          <img
            alt="existing"
            src={`${AVATAR_CDN}${currentUserAttributes.avatar_key}`}
          />
        );
      case PT_USE_CAMERA:
        return <RenderUseCameraFeed />;
      case PT_NONE:
      default:
        window.efs_debug && window.log("No picture detected");
        return null;
    }
  }
  return (
    <div className="create-pic-avatar-display">
      <div className="position-relative">
        <AvatarCircle
          given_name={currentUserAttributes.given_name}
          family_name={currentUserAttributes.family_name}
          borderStyle={previewType === PT_USE_CAMERA ? "recording-border" : ""}
        >
          {renderPicPreview()}
        </AvatarCircle>

        {previewType === PT_USE_CAMERA ? (
          <>
            <div className="takePicRedDot">
              <RecordingRedDot />
            </div>
            <div className="takePicControls">
              <TakePicControls />
            </div>
          </>
        ) : null}
      </div>
      <div className="createPictureTip">
        (this is how you will appear to others)
      </div>
    </div>
  );
};

export default AvatarDisplay;
